// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__274zK","toggle":"styles_toggle__3iJSD","preview":"styles_preview__2jtXc"};